const module = { name: 'theater/details/desktop.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as overlayAuto } from 'swug-fdRequire-call:shared/misc/overlayAuto';



import { default as closestTheaters } from 'swug-fdRequire-call:theater/details/desktop/closestTheaters';



import { default as exhibitorPoints } from 'swug-fdRequire-call:theater/details/shared/exhibitorPoints';



import { default as hearts } from 'swug-fdRequire-call:shared/utils/hearts';



import { default as loadCalendar } from 'swug-fdRequire-call:theater/details/shared/tdp.loadCalendar';



import { default as rottenTomatoesRating } from 'swug-fdRequire-call:shared/utils/rottenTomatoesRating';



import { default as showModals } from 'swug-fdRequire-call:theater/details/shared/tdp.showModals';



import { default as theaterAmenities } from 'swug-fdRequire-call:theater/shared/theaterAmenities';



import { default as theaterTicketingOptions } from 'swug-fdRequire-call:theater/shared/theaterTicketingOptions';



import { default as theaterConcessionAmenity } from 'swug-fdRequire-call:theater/shared/theaterConcessionAmenity';

function run() {
    checkDependencies(module.name, debugLog);
    showModals.init();
    if (document.querySelector('.js-domain-redirect-modal')) {
        return;
    }
    closestTheaters.init();
    theaterTicketingOptions.init();
    theaterAmenities.init();
    theaterConcessionAmenity.init();
    overlayAuto.init();
    hearts.init();
    rottenTomatoesRating.attach();
    loadCalendar.init();
    exhibitorPoints.init();
}
run();
export default module.exports;